import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import GlobalStyle from './globalStyle.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import api from './services/api'; // Certifique-se de ajustar o caminho, se necessário

const Root = () => {
  useEffect(() => {
    const fetchSiteVersion = async () => {
      try {
        const params = { DS_KEY_PARAMETRO: 'SITE_VERSION' };
        const response = await api.post('filter_parms', params);
        const siteVersion = response.data[0]?.DS_VALOR_PARAMETRO || '';

        const storedVersion = localStorage.getItem('SITE_VERSION');
        if (!storedVersion) {
          localStorage.setItem('SITE_VERSION', siteVersion);
        } else if (storedVersion !== siteVersion) {
          localStorage.setItem('SITE_VERSION', siteVersion);
          window.location.reload(true); // Recarrega com limpeza de cache
        }
      } catch (error) {
        console.error('Error fetching SITE_VERSION:', error);
      }
    };

    fetchSiteVersion(); // Busca inicial
    const interval = setInterval(fetchSiteVersion, 10000); // Verifica a cada 10 segundos
    return () => clearInterval(interval); // Limpa o intervalo ao desmontar
  }, []);

  return (
    <>
      <GlobalStyle />
      <App />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);
